import type { SupabaseClient } from '@supabase/supabase-js'
import { z } from 'zod'
import type { AppSupabaseClient } from '@/infrastructure/supabase/client'
import type { OverviewContractValueRepository } from '../../application/OverviewContractValueRepository'
import type { OverviewContractValue } from '../../domain/overviewContractValue'

const cents = z.coerce.number().int()

const resultSchema = z.object({
  season: z.string().nullable(),
  byType: z
    .array(
      z.object({
        contractType: z.enum(['RESIDENTIAL', 'COMMERCIAL', 'MULTIFAMILY']),
        signedCount: cents,
        signedValueCents: cents,
        awaitingSignatureCount: cents,
        awaitingSignatureValueCents: cents,
      }),
    )
    .nullable(),
  computedAt: z.string(),
})

export function parseOverviewContractValue(data: unknown): OverviewContractValue {
  const parsed = resultSchema.safeParse(data)
  if (!parsed.success) throw new Error('OVERVIEW_CONTRACT_VALUE_RESPONSE_INVALID')
  return parsed.data
}

export function createSupabaseOverviewContractValueRepository(
  client: AppSupabaseClient,
): OverviewContractValueRepository {
  return {
    async load(season) {
      const rpcClient = client as unknown as SupabaseClient
      const response = await rpcClient.rpc('overview_contract_value_by_type_v1', { p_season: season })
      if (response.error) throw new Error(response.error.message || 'OVERVIEW_CONTRACT_VALUE_FAILED')
      return parseOverviewContractValue(response.data)
    },
  }
}
